import { useEffect, useRef } from 'react';

import { Subscription } from 'rxjs';

export const useUnsubscribe = () => {
    const subscriptionsRef = useRef<Subscription[]>([]);

    useEffect(() => {
        return () => {
            subscriptionsRef.current.forEach((subscription) => {
                if (subscription?.unsubscribe) {
                    subscription.unsubscribe();
                }
            });
        };
    }, []);

    const pushSubscription = (subscription: Subscription) => {
        subscriptionsRef.current.push(subscription);
    };

    return pushSubscription;
};
